<template>
  <footer class="footer bg-white">
    <div class="container">
      <div class="">
        <ul class="nav nav-footer align-items-center">
          <li class="nav-item text-main-color">
            <a href="/#/privacy_policy" class="nav-link-main-color">
              Privacy Policy
            </a>
          </li>
          <li class="nav-item text-main-color">
            <a href="/#/terms_conditions" class="nav-link-main-color" target="_self" rel="noopener">
              Terms & Conditions
            </a>
          </li>
          <!--          <li class="nav-item">-->
          <!--            <a  class="nav-link-main-color" target="_blank" rel="noopener">-->
          <!--              Download-->
          <!--            </a>-->
          <!--          </li>-->
          <li class="ml-lg-auto">
            <li v-if="youtube_url.length > 0" class="nav-item">
              <a :href="youtube_url" class="nav-link" target="_blank" rel="noopener">
                <i class="fa fa-youtube-play fa-2x" aria-hidden="true"></i>
              </a>
            </li>
            <li v-if="instagram_url.length > 0" class="nav-item">
              <a :href="instagram_url" class="nav-link" target="_blank" rel="noopener">
                <i class="fa fa-instagram fa-2x" aria-hidden="true"></i>
              </a>
            </li>
            <li v-if="whatsapp_url.length > 0" class="nav-item">
              <a :href="whatsapp_url" class="nav-link" target="_blank" rel="noopener">
                <i class="fa fa-whatsapp fa-2x" aria-hidden="true"></i>
              </a>
            </li>
          </li>
        </ul>
      </div>

      <hr>
      <div class="row align-items-center justify-content-md-between">
        <div class="col-md-6">
          <div class="copyright">
            Copyright &copy; {{ year }} Snapture All Rights Reserved.
          </div>
        </div>

      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: 'app-footer',
  data() {
    return {
      year: '2024',
      youtube_url: 'https://www.youtube.com/watch?v=CE_ellIh8Ng&ab_channel=Snapture',
      instagram_url: 'https://www.instagram.com/snapture.io',
      whatsapp_url: 'https://wa.me/91045836',
    }
  }
};
</script>
<style>
</style>
